module.exports = __webpack_public_path__ + "static/media/QBT.14e78cfd.svg";